import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router';

import { Account } from '@/pages/Account';
import { Cards } from '@/pages/Cards';
import { Customize } from '@/pages/Customize';
import { Dashboard } from '@/pages/Dashboard';
import { NewPassword } from '@/pages/NewPassword';
import { KybQuestionnaire } from '@/pages/Onboarding';
import { KybResult } from '@/pages/Onboarding/ui/KybResult';
import { Payments } from '@/pages/Payments';
import { Profile } from '@/pages/Profile';
import { Registration } from '@/pages/Registration';
import { ResetPassword } from '@/pages/ResetPassword';
import { SignInPage } from '@/pages/SignInPage';
import { SignUpPage } from '@/pages/SignUpPage';
import { WelcomePage } from '@/pages/Welcome';

import { ErrorFallback } from '@/widgets/ErrorFallback';
import { PublicOnlyRoute } from '@/widgets/PublicOnlyRoute';
import { RegistrationRoutesLayout } from '@/widgets/RegistrationRoutesLayout';
import { RootLayout } from '@/widgets/RootLayout';

import { ROUTES } from '@/shared/lib';

import { RouteGuardProvider } from '../providers/RouteGuardProvider';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<ErrorFallback />} hasErrorBoundary>
      <Route element={<RouteGuardProvider />}>
        <Route element={<PublicOnlyRoute />}>
          <Route path={ROUTES.WELCOME} element={<WelcomePage />} />
          <Route path={ROUTES.SIGN_UP} element={<SignUpPage />} />
          <Route path={ROUTES.AUTH} element={<SignInPage />} />
          <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={ROUTES.NEW_PASSWORD} element={<NewPassword />} />
        </Route>

        <Route element={<RegistrationRoutesLayout />}>
          <Route path={ROUTES.REGISTRATION} element={<Registration />} />
          <Route
            element={<KybQuestionnaire />}
            path={ROUTES.KYB_QUESTIONNAIRE}
          />
          <Route element={<KybResult />} path={ROUTES.KYB_RESULT} />
        </Route>

        <Route path={ROUTES.ROOT} element={<RootLayout />}>
          <Route index element={<Dashboard />} />
          <Route path={ROUTES.PROFILE} element={<Profile />} />
          <Route path={ROUTES.PAYMENTS} element={<Payments />} />
          {/* TODO soon */}
          <Route path={ROUTES.CARDS} element={<Cards />} />
          {/* <Route path={ROUTES.CREATE_CARD} element={<CreateCard />} /> */}
          <Route path={ROUTES.ACCOUNT} element={<Account />} />
          <Route path={ROUTES.CUSTOMIZE} element={<Customize />} />
        </Route>
      </Route>
      <Route path={ROUTES.ANY} element={<Navigate to={ROUTES.ROOT} />} />
    </Route>,
  ),
);
